import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input, TextArea } from '../../components/ui/Input';
import { useAssessment } from '../../hooks/useAssessment';
import { SystemDefinition as SystemDefinitionType } from '../../types/assessment';
export function SystemDefinition() {
  const navigate = useNavigate();
  const {
    assessment,
    updateSystemDefinition
  } = useAssessment();
  const [formData, setFormData] = useState<SystemDefinitionType>(assessment.systemDefinition);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    updateSystemDefinition(formData);
    navigate('/assessment/regulation');
  };
  const isValid = formData.name && formData.description && formData.useCase;
  return <div className="max-w-3xl mx-auto animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-671">
      <div className="mb-8" data-id="element-672">
        <h1 className="text-3xl font-bold mb-3" data-id="element-673">Define AI System</h1>
        <p className="text-slate-400 text-lg" data-id="element-674">
          Describe the system you are assessing. This establishes the scope and
          context for your compliance evaluation.
        </p>
      </div>

      <Card data-id="element-675">
        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-676">
          <Input label="System Name" name="name" placeholder="e.g., Customer Support Sentiment Analyzer" value={formData.name} onChange={handleChange} required data-id="element-677" />

          <TextArea label="Description" name="description" placeholder="Technical description of what the model does..." rows={4} value={formData.description} onChange={handleChange} required data-id="element-678" />

          <TextArea label="Intended Use Case" name="useCase" placeholder="Where is it deployed? Who uses it? What decisions does it support?" rows={3} value={formData.useCase} onChange={handleChange} required data-id="element-679" />

          <TextArea label="Impact & Affected Stakeholders" name="impact" placeholder="Who is affected by the system's outputs? (e.g., employees, customers, public)" rows={3} value={formData.impact} onChange={handleChange} data-id="element-680" />

          <div className="pt-4 flex items-center justify-end space-x-4 border-t border-slate-700/50" data-id="element-681">
            <Button type="submit" disabled={!isValid} data-id="element-682">
              Continue to Regulation Selection
            </Button>
          </div>
        </form>
      </Card>
    </div>;
}